import React from 'react';
import Navbar from './navbar';
import logo from '../../image/logo.png';
import icon from '../../image/icone.png';
import { withRouter } from 'react-router-dom';
import './headerBreadcrumb.css';

const MainHeader = ({ user, location }) => {
  const { name } = user || {}; // Garante que user exista antes de acessar name

  // Mapear rotas para breadcrumbs com menu pai
  const routeMap = {
    '/': { name: 'Dashboard', icon: 'fa-tachometer-alt', parent: null },
    '/dashboard': { name: 'Dashboard', icon: 'fa-tachometer-alt', parent: null },
    '/contagemvolumetrica': {
      name: 'Contagem Volumétrica',
      parent: { name: 'Controlador' },
    },
    '/conlogusuario': {
      name: 'Log de Alterações',
    },
    '/cadcontrolador': { name: 'Controladores', parent: { name: 'Cadastro' } },
    '/cadplano': {
      name: 'Planos do Controlador',
      parent: { name: 'Controlador' },
    },
    '/cadintervalo': { name: 'Intervalos', parent: { name: 'Cadastro' } },
    '/cadtrocaplano': {
      name: 'Tabela de Troca de Plano',
      parent: { name: 'Controlador' },
    },
    '/cadusuario': { name: 'Usuários', parent: { name: 'Cadastro' } },
    '/cadgrupo': {
      name: 'Grupos de Usuário',
      parent: { name: 'Cadastro' },
    },
    '/cadgrupofisico': {
      name: 'Grupos Físicos',
      parent: { name: 'Cadastro' },
    },
    '/caddetector': { name: 'Detectores', parent: { name: 'Cadastro' } },
    '/caddataespecial': {
      name: 'Datas Especiais',
      parent: { name: 'Controlador' },
    },
    '/cadtipoalarme': {
      name: 'Tipos de Alarme',
      parent: { name: 'Cadastro' },
    },
    '/pluviometro': {
      name: 'Índice Pluviométrico',
      parent: { name: 'Relatórios' },
    },
    '/mapadefases': { name: 'Mapa de Fases' },
    '/temporealdashboard': {
      name: 'Tempo Real',
      parent: { name: 'Monitoramento' },
    },
    '/planoforcado': {
      name: 'Plano Forçado',
      parent: { name: 'Monitoramento' },
    },
    '/adaptativo': { name: 'Adaptativo', parent: { name: 'Monitoramento' } },
    '/logadaptativo': {
      name: 'Log Adaptativo',
      parent: { name: 'Relatórios' },
    },
    '/caderrogeral': { name: 'Erro Geral', parent: { name: 'Relatórios' } },
    '/caderro': {
      name: 'Erros de Controlador',
      parent: { name: 'Relatórios' },
    },
    '/sap': { name: 'Seleção Automática', parent: { name: 'Configurações' } },
    '/telegram': {
      name: 'Telegram',
      parent: { name: 'Notificações' },
    },
    '/log-adaptativo': {
      name: 'Histórico Adaptativo',
      parent: { name: 'Controlador' },
    },
    '/execplanoforcado': {
      name: 'Plano Forçado',
      parent: { name: 'Controlador' },
    },
    '/concontroladorerrogeral': {
      name: 'Alertas',
    },
    '/concontroladorerro': {
      name: 'Registro de Defeitos',
      parent: { name: 'Controlador' },
    },
    '/pluviometro-tempo-real': {
      name: 'Tempo Real',
      parent: { name: 'Índice Pluviométrico' },
    },
    '/pluviometro-historico': {
      name: 'Histórico',
      parent: { name: 'Índice Pluviométrico' },
    },
    '/pluviometro-mapa': {
      name: 'Mapa',
      parent: { name: 'Índice Pluviométrico' },
    },
    '/ticketsuporte': {
      name: 'Tickets de Suporte',
    },
    '/cameradeteccao': {
      name: 'Câmera de Detecção',
      parent: { name: 'Câmeras' },
    },
    '/cameramonitoramento': {
      name: 'Câmera Monitoramento',
      parent: { name: 'Câmeras' },
    },
    '/cadcamera': {
      name: 'Cadastro de Câmeras',
      parent: { name: 'Câmeras' },
    },
  };

  const currentRoute = routeMap[location.pathname] || { name: 'Página', icon: 'fa-file' };

  return (
    <header className="main-header">
      <a href="/#/" className="logo">
        <span className="logo-mini">
          <img src={icon} height="40" alt="" />
        </span>
        <span className="logo-lg">
          <img src={logo} height="40" alt="" />
        </span>
      </a>
      <nav className="navbar navbar-static-top">
        <a href="#" className="sidebar-toggle" role="button" aria-label="Toggle sidebar">
          <span className="sr-only">Toggle sidebar</span>
        </a>

        <div className="header-breadcrumb">
          <ol className="breadcrumb">
            {currentRoute.parent && <li className="active">{currentRoute.parent.name}</li>}
            <li className="active">{currentRoute.name}</li>
          </ol>
        </div>
        <div className="navbar-custom-menu" style={{ float: 'right' }}>
          <ul className="nav navbar-nav">
            <li style={{ lineHeight: '50px', marginRight: '10px' }}>
              <span
                className="user-greeting"
                style={{
                  color: 'white',
                  fontSize: '16px',
                }}
              >
                Olá, {name || 'Usuário'}
              </span>
            </li>
          </ul>
          <Navbar />
        </div>
      </nav>
    </header>
  );
};

export default withRouter(MainHeader);
